import { Grid, Button, Typography, Fade } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import refundService from 'v2/services/requestManagement/refund';

import useStyle from '../styles';

const RefundSelect = () => {
  const classes = useStyle();
  const [list] = useObservable(() => refundService.list(), []);

  const onUnCheckAll = useCallback(() => refundService.unCheckAllRefunds(), []);

  const selected = (list || []).filter((r) => r.checked);

  const quantity = selected?.length;

  const onClickAprove = useCallback(() => refundService.openMassApprove(), []);

  if (!quantity) return null;

  return (
    <Grid item xs={12}>
      <Fade in={true}>
        <div className={classes.content}>
          <Grid container justify='space-between' alignItems='center'>
            <Grid item md={6} xs={12}>
              <Typography variant='body1'>{quantity} solicitações selecionadas</Typography>
            </Grid>
            <Grid container md={6} xs={12} justify='flex-end' alignItems='center'>
              <Grid md={5} xs={12}>
                <Button fullWidth onClick={onUnCheckAll}>
                  Limpar seleção
                </Button>
              </Grid>
              <Grid md={7} xs={12}>
                <Button variant='contained' color='secondary' fullWidth onClick={onClickAprove}>
                  Reembolsar selecionados ({quantity})
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Fade>
    </Grid>
  );
};
export default RefundSelect;
